import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { ColorField } from '../components/Table/fields/ColorField';
import { TextField } from '../components/Table/fields/TextField';
import { Color } from '../types/entities/Color';
import {SPTextField} from "../components/Table/fields/SPTextField";
import {SPNumberField} from "../components/Table/fields/SPNumberField";

export const color: SchemaWithClient<Color> = {
  name: 'Color',
  pluralName: 'Color',
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    color: {
      name: 'HEX Code',
      required: true,
      fieldRenderer: ColorField,
      slidePaneFieldRenderer: SPTextField,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/colors'),
};
